import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  FlatList,
  ActivityIndicator,
} from "react-native";
import PortfolioClosedCard from "./portfolioClosedCard";
import { getClosedMarket } from "../redux/portfolio.action";
import { connect } from "react-redux";
import { Network } from "../../../utils/network";
import { globalImport } from "../../../common/globalImports";
import PortfolioSummary from "./portfolioSummary";
import {RefreshControl} from "react-native-web-refresh-control";
import {Color} from "../../../assets";
import {isMobile} from "../../../utils/commonMethods";
import {globalConfigurableData} from "../../../utils/globalConstant";

const PortfolioParentClosed = ({
  onClosedPortfolioClick,
  getClosedMarketRequest,
  closedHeader,
  closedMarketDetails,
  closedMarketDetailsPage,
  closedMarketLoading,
  navigation,
  isLiveSelected,
  livePortfolioData,
}) => {
  const [load, setLoad] = useState(true);
  //const [pageNum, setPageNum] = useState(1);

  useEffect(() => {
    if (!load) {
      return;
    }
    if (!closedMarketDetailsPage) {
      closedMarketDetailsPage = 0;
    }
    getClosedMarketRequest({ limit: 10, page: closedMarketDetailsPage + 1 });

    setLoad(false);
    //setPageNum(pageNum + 1);
  }, [load]);

  const setLoadMore = () => {
    //alert(1);
    setLoad(true);
  };

  const PullToRefresh = () => {
    getClosedMarketRequest({ limit: 10, page: 0 });
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {closedMarketLoading ? (
          <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
        ) : null}
      </View>
    );
  };

  const onPressEvent = (item) => {
    navigation.push("PortfolioStack", {
      screen: "closedPortfolioDetail",
      params: { selectedClosedProbe: item },
    });
  };
  return (
    <View
      style={[
        globalImport.isWeb ? { flex: 1 } : { marginBottom: 0, flexGrow: 1 },
      ]}
    >
      <FlatList
        data={closedMarketDetails}
        renderItem={({ item }) => (
          <TouchableOpacity onPress={() => onClosedPortfolioClick(item)}>
            <PortfolioClosedCard item={item} />
          </TouchableOpacity>
        )}
        ListHeaderComponent={()=>{
          return (<PortfolioSummary
              isLiveChecked={isLiveSelected}
              closedHeader={closedHeader}
              data={livePortfolioData}
          />)
        }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 100 }}
        //ListEmptyComponent={ListEmptyComponent}
        keyExtractor={(item, index) => index.toString()}
        bounces={false}
        onEndReachedThreshold={0.2}
        refreshing={closedMarketLoading}
        ListFooterComponent={renderFooter}
        onRefresh={PullToRefresh}
        refreshControl={
          isMobile()
              ? <RefreshControl colors={[Color.tradexBlue]} refreshing={closedMarketLoading} onRefresh={PullToRefresh} />
              : null
        }
        onEndReached={
          closedHeader?.total_events > closedMarketDetails?.length &&
          !closedMarketLoading
            ? setLoadMore
            : null
        }
        scrollEnabled={true}
      />
    </View>
  );
};

const mapStateToProps = ({ portfolioReducer }) => ({
  closedMarketDetails: portfolioReducer.closedMarketDetails,
  closedMarketDetailsPage: portfolioReducer.closedMarketDetailsPage,
  closedMarketLoading: portfolioReducer.closedMarketLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getClosedMarketRequest: (data) => {
    dispatch(getClosedMarket(data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PortfolioParentClosed);
